import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      flex: 1,
    },
    button: {
      width: 285,
      height: 46,
      marginTop: theme.spacing(5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      '&:last-of-type': {
        marginTop: theme.spacing(2),
      },
    },
  }),
);
